import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div<{ align: string; backgroundColor?: string }>`
  background-color: ${(props) => props.backgroundColor || props.theme.background};
  padding: 15px 15px 10px;
  border-radius: 4px;
  text-align: ${(props) => props.align};
`;

export const AgentName = styled.div`
  display: inline-flex;
  background-color: ${(props) => props.theme.backgroundLight};
  padding: 5px 10px;
  height: 40px;
  align-items: center;

  p {
    font-size: 14px;
  }
`;

export const BackLink = styled.button`
  display: none;
  color: ${(props) => props.theme.primary};
  text-decoration: underline;
  font-size: 14px;
  margin-top: 5px;

  @media (${laptopMediumMax}) {
    display: block;
  }
`;

export default Container;
